import React from "react";
import { CountdownCircleTimer } from "react-countdown-circle-timer";

import "./Styles.css";

const renderTime = ({ remainingTime }) => {
  function fancyTimeFormat(duration) {
    var hrs = ~~(duration / 3600);
    var mins = ~~((duration % 3600) / 60);
    var secs = ~~duration % 60;
    var ret = "";
    if (hrs > 0) {
      ret += "" + hrs + ":" + (mins < 10 ? "0" : "");
    }
    ret += "" + mins + ":" + (secs < 10 ? "0" : "");
    ret += "" + secs;
    return ret;
  }
  if (remainingTime === 0) {
    return <div className="a-timer">Times up...</div>;
  }
  return (
    <div className="a-timer">
      <div className="value">{fancyTimeFormat(remainingTime)}</div>
      <div className="text">seconds</div>
    </div>
  );
};

function AnimatedTimer({ timer = 300, setScreen, checkStatus }) {

  return (
    <div className="timer-container">
      <div className="timer-wrapper">
        <CountdownCircleTimer
          isPlaying
          duration={timer}
          colors={["var(--primary-theme-color)"]}
          onComplete={() => setScreen("PENDING_STATUS")}
          size={100}
          strokeWidth={8}
          onUpdate={(remainingTime) => {
            if(remainingTime % 5 === 0)
              checkStatus();
          }}
        >
          {renderTime}
        </CountdownCircleTimer>
        <h6>Processing your payment...</h6>
        <p>Please wait while we fetch your payment status</p>
      </div>
    </div>
  );
}

export default AnimatedTimer;
